// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../assets/css/module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#afis-app .com-mod-section-container .com-mod-section-header[data-v-2618132f] {
  margin-bottom: 20px;
}
.adjust-up[data-v-2618132f] {
  margin-bottom: 35px;
}
`, "",{"version":3,"sources":["webpack://./src/components/SectionComponents/Holdings.vue","webpack://./Holdings.vue"],"names":[],"mappings":"AAEC;EACC,mBAAA;ACAF;ADEC;EACC,mBAAA;ACAF","sourcesContent":["\n\t@import '~_css_/module.css';\n\t#afis-app .com-mod-section-container .com-mod-section-header {\n\t\tmargin-bottom: 20px;\n\t}\n\t.adjust-up {\n\t\tmargin-bottom: 35px; //need to give extra space in breakdown module to combat CG bootstrap files and match American Funds.\n\t}\n","@import '~_css_/module.css';\n#afis-app .com-mod-section-container .com-mod-section-header {\n  margin-bottom: 20px;\n}\n.adjust-up {\n  margin-bottom: 35px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
